import React, { FC } from 'react';
import { RootState, useSelector } from 'src/store';
import modalSlickAlt from 'src/images/modalSlickAlt.png';
import { trackingList } from 'src/utils/valueHTML';
import { getFontURL } from 'src/utils/getFontUrl';

const AutoSquareSlideHTML: FC = () => {
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );
  const radius = useSelector((state: RootState) => state.imageUpload.radius);

  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  const btnAgain = useSelector((state: RootState) => state.buttons.btnAgain);

  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const button1 = useSelector((state: RootState) => state.trackings.button1);
  const button2 = useSelector((state: RootState) => state.trackings.button2);

  const switchState = useSelector(
    (state: RootState) => state.switchButton.switchState
  );
  const switchSpeed = useSelector(
    (state: RootState) => state.switchButton.switchSpeed
  );
  const bgOpacity = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );

  const backgroundDimmed = bgOpacity?.bgDimmed / 100;
  const displayValue = backgroundDimmed >= 0.01 ? backgroundDimmed : 0.7;
  const multiTitleFontURL = getFontURL(fontFamily?.multi_title);
  const multiSubTitleFontURL = getFontURL(fontFamily?.multi_sub_title);
  const multiLeftButtonFontURL = getFontURL(btnFontFamily?.multi_left_button);
  const multiRightButtonFontURL = getFontURL(btnFontFamily?.multi_right_button);
  // const multiTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.multi_title}`;
  // const multiSubTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.multi_sub_title}`;
  // const multiLeftButtonFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_left_button}`;
  // const multiRightButtonFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_right_button}`;

  const style = `
  @Font-face {
    font-family: 'multiTitle';
    src: url(${multiTitleFontURL});
  }
  @Font-face {
    font-family: 'multiSubTitle';
    src: url(${multiSubTitleFontURL});
  }
  @Font-face {
    font-family: 'multiLeftButton';
    src: url(${multiLeftButtonFontURL});
  }
  @Font-face {
    font-family: 'multiRightButton';
    src: url(${multiRightButtonFontURL});
  }
    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
      width: 100%;
      height: 100%;

      overflow: hidden;
      position: relative;
      background: none;
    }
    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, ${displayValue});
    }

    .modal_wrapper {
      width: 100%;
      padding: 18px;

      display: flex;
      flex-direction: column;

      position: absolute;
      top: 50%;
      transform: translate(0%, -50%);
      
      border-radius: ${radius?.background}px;
      background: transparent;

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }
    
    .slick_page {
      display: flex;      
      justify-content: space-between;
      align-items: center;     
      padding: 0.19rem 0.5rem;
      position: absolute;
      
      right: 6px;
      bottom: 6px;
      display:flex;
      gap: 0.2rem;
    
      color: #fff;
      font-family: Roboto;
      font-size: 0.7rem;
      font-weight: 400;

      border-radius: 999px;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 1;
      
    }
    .slick_wrapper {
      position: relative;
    }
    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list,
    .slick_wrapper .slick-track div,
    .slick_wrapper .slick-track img {
      width: 100%;
      aspect-ratio: 1;
      outline: none;
    }
    .slick_wrapper .slick-list {
      overflow: hidden;
      border-radius: ${radius?.multi_image}px ${radius?.multi_image}px ${
    radius?.multi_image
  }px ${radius?.multi_image}px;
    }
    .slick_wrapper .slick-track {
      display: flex;
    }
    .slick_wrapper .slick-track img {
      object-fit: cover;
    }


    .btn_wrapper {
      margin-top: 11px;
      padding: 0rem 0rem;

      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .btn_wrapper button {
      border: 0;
      background-color: transparent;
      outline: 0;      
    }
    .btn_wrapper .style01 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      
      font-size: ${btnFontSize?.multi_left_button}rem;
      font-weight: ${btnFontWeight?.multi_left_button};
      color: ${btnColor?.multi_left_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_left_button
        )
          ? btnFontFamily?.multi_left_button
          : 'multiLeftButton'
      };
      padding-left: 0.5rem;
      text-align: left;
      background-color:rgba(${btnBgColorR?.multi_left_button},${
    btnBgColorG?.multi_left_button
  }, ${btnBgColorB?.multi_left_button}, ${btnBgColorA?.multi_left_button});
    }
    .btn_wrapper .style02 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-size: ${btnFontSize?.multi_right_button}rem;
      font-weight: ${btnFontWeight?.multi_right_button};
      color: ${btnColor?.multi_right_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_right_button
        )
          ? btnFontFamily?.multi_right_button
          : 'multiRightButton'
      };
      text-align: right;
      background-color:rgba(${btnBgColorR?.multi_right_button},${
    btnBgColorG?.multi_right_button
  }, ${btnBgColorB?.multi_right_button}, ${btnBgColorA?.multi_right_button});
    }

    @media screen and (min-width: 540px) and (max-width: 1024px) {
      .modal_wrapper {
        width: 50%;
        margin: 0 25%;
      }       
    }
  `;

  // let deeplink_list = `[`;
  // for (let i = 0; i < deeplink?.multi_image?.length; i++) {
  //   deeplink_list += `'${deeplink?.multi_image?.[i]}'`;
  //   if (i !== deeplink?.multi_image?.length - 1) deeplink_list += ',';
  // }
  // deeplink_list += ']';

  const deeplink_list = JSON.stringify(deeplink?.multi_image);

  const html = `
    <div class="root">
      <div class="background" onclick="appboyBridge.logClick('background'); appboyBridge.closeMessage();"></div>
      <div class="modal_wrapper">
        <div class="slick_wrapper">
          <div class="slick_slider">${bgImage?.multi_image
            ?.map(
              (data: any, idx: number) => `
        <div>
          <img class="image" src="${
            data && data !== '' ? data : modalSlickAlt
          }" alt="" />
        </div>
      `
            )
            .join('')}
          </div>
          ${
            bgImage?.multi_image?.length !== 1
              ? `
            <div class="slick_page">
              <span class="slick_number"></span>
              <span style="color:#828282;">/</span>
              <span style="color:#828282;">${bgImage?.multi_image?.length}</span>
            </div>
          `
              : ''
          }
        </div>
        <div class="btn_wrapper">
          <button class="style01">
            ${btnText?.multi_left_button}
          </button>
          <div style="display:flex; justify-content: center; align-items: center">
            <button class="style02">
              ${btnText?.multi_right_button}                
            </button>
            <span class="material-icons" style="font-size: ${btnFontSize?.multi_right_button +
              0.35}rem; color:${btnColor?.multi_right_button};">
            close</span>
          </div>
         
        </div>
      </div>
       <div id="deeplink" style="display:none;">
            ${deeplink_list}
       </div>          
    </div>
  `;

  let button_list = '[';
  for (let i = 0; i < btnText?.multi_left_button?.length; i++) {
    button_list += `["${btnText?.multi_left_button?.[i]}", "${btnText?.multi_right_button?.[i]}"]`;
    if (i !== btnText?.multi_left_button?.length - 1) button_list += ',';
  }
  button_list += ']';

  let tracking_list = '[';
  for (let i = 0; i < tracking?.multi_image?.length; i++) {
    tracking_list += `["${tracking?.multi_image?.[i]}", "${tracking?.multi_left_button?.[i]}", "${tracking?.multi_right_button?.[i]}"],`;
  }
  tracking_list += ']';

  const tracking_button_list = trackingList(
    'AUTO SQUARE SLIDE',
    button1,
    button2
  );

  const js = `
    document.addEventListener("DOMContentLoaded", function(){
      $('.slick_slider').slick({
        arrows: false,
        infinite: true,
        dots: false,
        speed: 300,
        touchThreshold: 300,
        autoplay: ${switchState},
        autoplaySpeed: ${switchSpeed * 1000}
      });
  
      $('.contents_slider').slick({
        arrows: false,
        dots: false,
        fade: true,
        speed: 300,
        swipe: false
      });

      let currentIndex = 0;
      let button = ${button_list};
      $('.style01').text(button[currentIndex][0]);
      $('.style02').text(button[currentIndex][1]);
      $('.slick_number').text(currentIndex+1);
      $('.slick_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
        currentIndex = $('.slick_slider').slick('slickCurrentSlide');
        $('.contents_slider').slick('goTo', currentIndex);
        $('.slick_number').text(currentIndex+1);
        $('.style01').text(button[currentIndex][0]);
        $('.style02').text(button[currentIndex][1]);
      });

      
      const content = document.getElementById("deeplink").textContent;
      const link = content.replace(/\\n|\\t/g, "").trim();
      const deeplink = JSON.parse(link);
      

      let tracking = ${tracking_list};
      let button1 = ${tracking_button_list[0]};
      let button2 = ${tracking_button_list[1]};
      $('.image').click(function() {
        try {
          appboyBridge.logClick(tracking[currentIndex][0]);
          if (button1[0].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[0].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {

        } finally {
          window.location = deeplink[currentIndex];
        }        
      });
      $('.style01').click(function() {
        try {
          appboyBridge.logClick(tracking[currentIndex][1]);
          if ("${btnAgain?.type}" === "attribute") {
            appboyBridge.getUser().setCustomUserAttribute("${
              btnAgain?.multi_left_button
            }", new Date());
          }
          if ("${btnAgain?.type}" === "event") {            
            appboyBridge.logCustomEvent("${btnAgain?.multi_left_button}");
          }
        } catch (err) {}
     
        try {
          if (button1[1].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[1].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        appboyBridge.closeMessage();
      });
      $('.style02').click(function() {
        try {
          appboyBridge.logClick(tracking[currentIndex][2]);
          if (button1[2].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[2].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {} finally {
          appboyBridge.closeMessage();
        }        
      });
    });
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta
          httpEquiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta httpEquiv="Expires" content="0" />
        <meta httpEquiv="Pragma" content="no-cache" />

        {/* google font */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.css"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/icon?family=Material+Icons"
        />
        {/* jquery */}
        <script id="test" src="https://code.jquery.com/jquery-3.6.0.min.js" />
        <script src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js" />
        <style dangerouslySetInnerHTML={{ __html: style }} />
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }} />
      <script dangerouslySetInnerHTML={{ __html: js }} />
    </>
  );
};

export default AutoSquareSlideHTML;
